import { getLink } from "../../../utils/utils";

const content = {
	esp: (
		`
		<p class="mb-3">
			Ekologio iĝis nun laŭmoda vorto. Oni parolas pri «ekologio de urbo», «ekologio de kulturo» ktp. 
			Tamen la vorto, proponita de E. Gekkel en 1866 jaro, origine rilatis nur al naturo. 
			Ĝi signifis «scienco pri la hejmo», kaj verdire, oni ne povus eltrovi pli taŭgan vorton: ja ĝuste naturo estas nia komuna hejmo, nia prapatrujo. 
			Antaŭ jarcento oni ankoraŭ ne povis konscii tion tiom profunde kaj amplekse, kiel ni nun; des pli valoras genia intuicio de tiamaj esploristoj.
		</p>
		
		<p class="mb-3">
			Sed kion ni faras nun sur nia planedo – nia komuna hejmo? Ĉu pliboniĝis la vivo dum ĉi-lasta jarcento?
		</p>
		
		<p class="mb-3">
			En 1986 en Sovetunio estis kreita filmo «Kin-dza-dza», antaŭnelonge tradukita kaj sonigita en Esperanto. 
			Verŝajne, multaj e-istoj jam vidis ĝin. 
			Ĉu ili rekonis en ĝi nian nunan vivon?
		</p>
		
		<p class="mb-3">
			La ŝanĝoj en vivo  estas teruraj, kiam ili venas frape, kiam revolucio okazas dum kelkaj tagoj aŭ monatoj. 
			Sed kiam estonto venas malrapide, poiomete, kiel natura sekvo de plej etaj, nerimarkeblaj, ĉiutagaj eventoj – tiam ĝi ne timigas, sed akcepteblas kiel sola ebla, natura sekvo de aferoj. 
			Oni pensas, ke aliel eĉ ne povus okazi…
		</p>
		
		<p class="mb-3">
			En la filmo, loĝantoj de iu planedo (kompreneble, ne la popolo, sed ties gvidantoj) vorhakis verdaĵon, kaj la planedo preskaŭ perdis akvon kaj aeron, troviĝis inundita de sablo.
		</p>
		
		<p class="mb-3">
			Homoj tie uzas postsekvojn de potencaj teknologioj, ili povas flugi al aliuj galaksioj kaj steloj, uzante por tio la forton de gravito, - sed tion ĉion inventis iliaj prapatroj, kaj la tekniko uzeblas, ni diru, «aŭtomate», sen kompreno pri kialoj de ĝia funkciado. 
			La arto degradis ĝis la plej mizera stato, trovebla, eble, ĉe ŝtonepokaj kanibaloj – sed transportiloj estas perfektaj. 
			Malriĉaj homoj manĝas «plastan kaĉon» kaj ricevas po unu taso da akvo tage. 
			Ankoraŭ unu planedo estas jam tute senviva, ĉar ĝiaj loĝantoj (certe, denove iliaj gvidantoj) forvendis tutan aeron de ĝi.
		</p>
		
		<p class="mb-3">
			La filmo, mi ripetas, estas kreita antaŭ pli ol 30 jaroj. 
			Ĉu vi ne sentas, ke ni JAM vivas en la estonto, priskribita en ĝi?
		</p>
		
		<p class="mb-3">
			Ĉu ni jam ne loĝas en la mondo, kie oni freneze forhakas verdaĵon por konstrui domojn kaj golfejojn (mi temas almenaŭ pri mia lando kaj Turkio)? 
			Kaj se oni ne faras tion en la t.n. «riĉa mondo», sed tamen «la hejmo» – nia planedo – estas komuna, kaj aero kaj oksigeno en ĝi (dume) apartenas al ĉiuj, kaj manko da ili ankaŭ influos ĉiujn.
		</p>
		
		<p class="mb-3">
			Ĉu ni ne loĝas nun en domoj kun plastaj mebloj, plastaj fenestroj, plastaj tapetoj, hejmŝtofaĵoj, plasta manĝilaro? 
			Ĉu ni ne surmetas sintetikajn vestaĵojn, ĉu ne manĝas manĝaĵojn, duone konsistantajn el GMO kaj kemiaj ingrediencoj, kiel diversaj E-330, E-450, E-171 ktp, ktp? 
			Denove oni povas diri, ke en riĉaj landoj tiuj substancoj estas malpermesitaj, kaj nur eksportataj al la t.n. «tria mondo». 
			Sed denove mi respondas, ke la domo estas komuna, kaj procedoj en unu parto ne povas ne influi aliujn. 
			Ekzemple, ju pli malbona iĝas vivo en iu triamonda lando, des pli grandnombre ĝiaj loĝantoj elmigras al riĉaj landoj kun bonaj vivkondiĉoj. 
			Ja la hejmo estas komuna…
		</p>
		
		<p class="mb-3">
			Do, la vorto «ekologio» komence de XXI jc reekhavis sian originan, filologian sencon: ĝi estas scienco pri la stato de nia komuna hejmo - planedo Tero. 
			Kaj reguloj por konduto (ne malpurigi, ne insulti najbarojn, ne prirabi kaj ne mortigi ilin, ne pretendi perforte regi samrajtajn kunloĝantojn) devas esti samaj por ĉiuj teranoj. 
			Aliel nia Tero facile transformiĝos en imagitan planedon Kin-dza-dza, kaj ĝia imagita nuno iĝos nia kruele malica estonto.
		</p>
	`
	)
}

const itemName = {
	esp: 'Iom pri nuntempa ekologio'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp:{
		itemName: itemName.esp,
		itemContent: content.esp
	}
}

export default item;